import axios from '@axios'

export default {
    namespaced: true,
    state: {
        usuarios: [],
        depPermitoUsuario: [],
        depFaltantes: [],
        permiso_departamento: [],
        cargos: [],
        divisiones: [],
        departamentos: [],
        depJerarquia: [],
        tipoDocumento: [],
        revisionDocumento: [],
        manualesFunciones: [],
        manualesFunsionesAll: [],
        manualFuncion: {},
        organigramaGeneral: {},
        organigramaDepartamental: {},
        ultimaRevision: {},
        niveles: [],
        areas: [],
        competenciaComportamental: [],
        competenciaEspecifica: [],
        descargarDocumento: [],
        colaboradores: [],
        seccionesJerarquia: [],
        manualesProcedimientos: [],
        manualProcedimiento: [],
        manualesProcedimientosAll: [],
        descargarDiagramFlujo: [],
        instructivo: [],
        instructivos: [],
        instructivosAll: [],
    },
    getters: {
        getUsuarios(state) {
            return state.usuarios
        },
        getDepartamentoPermitidoXusuario(state) {
            return state.depPermitoUsuario
        },
        getDepFaltantes(state) {
            return state.depFaltantes
        },
        getPermisosDepartamento(state) {
            return state.permiso_departamento
        },
        getCargos(state) {
            return state.cargos
        },
        getDivisiones(state) {
            return state.divisiones
        },
        getDepartamentos(state) {
            return state.departamentos
        },
        getDepJerarquia(state) {
            return state.depJerarquia
        },
        getTipoDocumento(state) {
            return state.tipoDocumento
        },
        getRevisionDocumento(state) {
            return state.revisionDocumento
        },
        getManualesFuncionesAll(state) {
            return state.manualesFuncionesAll
        },
        getManualesFunciones(state) {
            return state.manualesFunciones
        },
        getManualFuncion(state) {
            return state.manualFuncion
        },
        getOrganigramaGeneral(state) {
            return state.organigramaGeneral
        },
        getOrganigramaDepartamental(state) {
            return state.organigramaDepartamental
        },
        getUltimaRevision(state) {
            return state.organigramaGeneral
        },
        getNiveles(state) {
            return state.niveles
        },
        getAreas(state) {
            return state.areas
        },
        getCompetenciasComportamentales(state) {
            return state.competenciaComportamental
        },
        getCompetenciasPorArea(state) {
            return state.competenciaEspecifica
        },
        getColaboradores(state) {
            return state.colaboradores
        },
        getSeccionesJerarquia(state) {
            return state.seccionesJerarquia
        },
        getManualesProcedimientos(state) {
            return state.manualesProcedimientos
        },
        getManualProcedimiento(state) {
            return state.manualProcedimiento
        },
        getManualesProcedimientosAll(state) {
            return state.manualesProcedimientosAll
        },
        getDescargarDiagramaFlujo(state) {
            return state.descargarDiagramFlujo
        },
        getInstructivo(state) {
            return state.instructivo
        },
        getInstructivos(state) {
            return state.instructivos
        },
        getInstructivosAll(state) {
            return state.instructivosAll
        },
        getDescargarDocumento(state) {
            return state.descargarDocumento
        },
    },
    mutations: {
        SET_USUARIOS(state, usuarios) {
            state.usuarios = usuarios
        },
        SET_DEPFALTANTES(state, depFaltantes) {
            state.depFaltantes = depFaltantes
        },
        SET_DEP_PERMITIDO_USUARIO(state, depPermitoUsuario) {
            state.depPermitoUsuario = depPermitoUsuario
        },
        SET_PERMISOS_DEPARTAMENTO(state, permiso_departamento) {
            state.permiso_departamento = permiso_departamento
        },
        SET_CARGOS(state, cargos) {
            state.cargos = cargos
        },
        SET_DIVISIONES(state, divisiones) {
            state.divisiones = divisiones
        },
        SET_DEPARTAMENTOS(state, departamentos) {
            state.departamentos = departamentos
        },
        SET_DEPJERARQUIA(state, depJerarquia) {
            state.depJerarquia = depJerarquia
        },
        SET_TIPO_DOCUMENTO(state, tipoDocumento) {
            state.tipoDocumento = tipoDocumento
        },
        SET_REVISION_DOCUMENTO(state, revisionDocumento) {
            state.revisionDocumento = revisionDocumento
        },
        SET_MANUALES_FUNCIONES_ALL(state, manualesFuncionesAll) {
            state.manualesFuncionesAll = manualesFuncionesAll
        },
        SET_MANUALES_FUNCIONES(state, manualesFunciones) {
            state.manualesFunciones = manualesFunciones
        },
        SET_MANUAL_FUNCION(state, manualFuncion) {
            state.manualFuncion = manualFuncion
        },
        SET_ORGANIGRAMA_GENERAL(state, organigramaGeneral) {
            state.organigramaGeneral = organigramaGeneral
        },
        SET_ORGANIGRAMA_DEPARTAMENTAL(state, organigramaDepartamental) {
            state.organigramaDepartamental = organigramaDepartamental
        },
        SET_ULTIMA_REVISION(state, ultimaRevision) {
            state.ultimaRevision = ultimaRevision
        },
        SET_NIVELES(state, niveles) {
            state.niveles = niveles
        },
        SET_AREAS(state, areas) {
            state.areas = areas
        },
        SET_COMPETENCIAS_COMPORTAMENTALES(state, competenciaComportamental) {
            state.competenciaComportamental = competenciaComportamental
        },
        SET_COMPETENCIAS_X_AREA(state, competenciaEspecifica) {
            state.competenciaEspecifica = competenciaEspecifica
        },
        SET_DESCARGAR_DIAGRAMA(state, descargarDiagramFlujo) {
            state.descargarDiagramFlujo = descargarDiagramFlujo
        },
        SET_COLABORADORES(state, colaboradores) {
            state.colaboradores = colaboradores
        },
        SET_SECCIONES_JERARQUIA(state, seccionesJerarquia) {
            state.seccionesJerarquia = seccionesJerarquia
        },
        SET_MANUALES_PROCEDIMIENTOS(state, manualesProcedimientos) {
            state.manualesProcedimientos = manualesProcedimientos
        },
        SET_MANUAL_PROCEDIMIENTO(state, manualProcedimiento) {
            state.manualProcedimiento = manualProcedimiento
        },
        SET_MANUALES_PROCEDIMIENTOS_ALL(state, manualesProcedimientosAll) {
            state.manualesProcedimientosAll = manualesProcedimientosAll
        },
        SET_INSTRUCTIVO(state, instructivo) {
            state.instructivo = instructivo
        },
        SET_INSTRUCTIVOS(state, instructivos) {
            state.instructivos = instructivos
        },
        SET_INSTRUCTIVOS_ALL(state, instructivosAll) {
            state.instructivosAll = instructivosAll
        },
        SET_DescargarDocumentos(state, descargarDocumento) {
            state.descargarDocumento = descargarDocumento
        },
    },
    actions: {
        fetchUsuarios({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/sistemaDocumentos/usuarios')
                    .then(response => {
                        commit('SET_USUARIOS', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchDepartamentoPermitidoXusuario({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/sistemaDocumentos/departamentoPermitidoXusuario/', { params: data })
                    .then(response => {
                        commit('SET_DEP_PERMITIDO_USUARIO', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchDepFaltantes({ commit }, id_usuario) {
            return new Promise(resolve => {
                axios
                    .get(`/api/auth/sistemaDocumentos/dep_faltantes/${id_usuario}`)
                    .then(response => {
                        commit('SET_DEPFALTANTES', response.data)
                        resolve()
                    })
                    .catch(error => {
                        console.error(error)
                    })
            })
        },
        fetchPermisosDepartamento({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/sistemaDocumentos/permisosDepartamento')
                    .then(response => {
                        commit('SET_PERMISOS_DEPARTAMENTO', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCargos({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/sistemaDocumentos/cargos')
                    .then(response => {
                        commit('SET_CARGOS', response.data)
                        resolve()
                    })
                    .catch(error => {
                        console.error(error)
                        reject(error)
                    })
            })
        },
        fetchDivisiones({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/sistemaDocumentos/divisiones', { params })
                    .then(response => {
                        commit('SET_DIVISIONES', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        console.error(error)
                        reject(error)
                    })
            })
        },
        fetchDepartamentos({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/sistemaDocumentos/departamentos')
                    .then(response => {
                        commit('SET_DEPARTAMENTOS', response.data)
                        resolve()
                    })
                    .catch(error => {
                        console.error(error)
                        reject(error)
                    })
            })
        },
        fetchDepJerarquia({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/sistemaDocumentos/dep_jerarquia')
                    .then(response => {
                        commit('SET_DEPJERARQUIA', response.data)
                        resolve()
                    })
                    .catch(error => {
                        console.error(error)
                        reject(error)
                    })
            })
        },
        fetchTipoDocumento({ commit }) {
            return new Promise(resolve => {
                axios
                    .get('/api/auth/sistemaDocumentos/tipo_documento')
                    .then(response => {
                        commit('SET_TIPO_DOCUMENTO', response.data)
                        resolve()
                    })
                    .catch(error => {
                        console.error(error)
                    })
            })
        },
        fetchRevisionDocumento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/sistemaDocumentos/revision_documento/', { params: data })
                    .then(response => {
                        commit('SET_REVISION_DOCUMENTO', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        console.error(error)
                        reject(error)
                    })
            })
        },
        fetchManualesFuncionesAll({ commit }, co_departamento) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/sistemaDocumentos/manuales_funciones_all/${co_departamento}`)
                    .then(response => {
                        commit('SET_MANUALES_FUNCIONES_ALL', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchManualesFunciones({ commit }, co_departamento) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/sistemaDocumentos/manuales_funciones/${co_departamento}`)
                    .then(response => {
                        commit('SET_MANUALES_FUNCIONES', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchManualFuncion({ commit }, co_documento) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/sistemaDocumentos/manual_funcion/${co_documento}`)
                    .then(response => {
                        commit('SET_MANUAL_FUNCION', response.data[0])
                        resolve(response.data.length)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchOrganigramaGeneral({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/sistemaDocumentos/organigramaGeneral`)
                    .then(response => {
                        commit('SET_ORGANIGRAMA_GENERAL', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchOrganigramDepartamental({ commit }, co_departamento) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/sistemaDocumentos/organigramaDepartamental`, {
                        params: { co_departamento },
                    })
                    .then(response => {
                        commit('SET_ORGANIGRAMA_DEPARTAMENTAL', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchOrganigramaDepXseccion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/sistemaDocumentos/organigramaDepXseccion', { params: data })
                    .then(response => {
                        commit('SET_ORGANIGRAMA_DEPARTAMENTAL', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchValidarNombreDoc(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/sistemaDocumentos/verificarNombreDoc/', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUltimaRevision({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/sistemaDocumentos/ultimaRevision/', { params: data })
                    .then(response => {
                        commit('SET_ULTIMA_REVISION', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchNiveles({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/sistemaDocumentos/niveles')
                    .then(response => {
                        commit('SET_NIVELES', response.data)
                        resolve()
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchAreas({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/sistemaDocumentos/areas')
                    .then(response => {
                        commit('SET_AREAS', response.data)
                        resolve()
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCompetenciasComportamentales({ commit }, co_nivel) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/sistemaDocumentos/competenciaComportamental/${co_nivel}`)
                    .then(response => {
                        commit('SET_COMPETENCIAS_COMPORTAMENTALES', response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCompetenciasPorArea({ commit }, co_area) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/sistemaDocumentos/competenciaEspecifica/${co_area}`)
                    .then(response => {
                        commit('SET_COMPETENCIAS_X_AREA', response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        getEliminarDocumento(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/sistemaDocumentos/eliminarDocumento', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        getEliminarFoto() {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/sistemaDocumentos/eliminarFoto')
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchDescargarDocumentos({ commit }, data) {
            return new Promise((resolve, reject) => {
                var link = '/api/auth/sistemaDocumentos/descargarDocumento'
                axios({ method: 'post', url: link, responseType: 'blob', data })
                    .then(response => {
                        commit('SET_DescargarDocumentos', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchColaboradores({ commit }, co_jerarquia) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/sistemaDocumentos/colaboradores/${co_jerarquia}`)
                    .then(response => {
                        commit('SET_COLABORADORES', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchSeccionesJerarquia({ commit }, co_jerarquia) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/sistemaDocumentos/seccionesJerarquia/${co_jerarquia}`)
                    .then(response => {
                        commit('SET_SECCIONES_JERARQUIA', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchManualesProcedimientos({ commit }, co_departamento) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/sistemaDocumentos/manuales_procedimientos/${co_departamento}`)
                    .then(response => {
                        commit('SET_MANUALES_PROCEDIMIENTOS', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchManualProcedimiento({ commit }, co_documento) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/sistemaDocumentos/manual_procedimiento/${co_documento}`)
                    .then(response => {
                        commit('SET_MANUAL_PROCEDIMIENTO', response.data[0])
                        resolve(response.data.length)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchManualesProcedimientosAll({ commit }, co_departamento) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/sistemaDocumentos/manuales_procedimientos_all/${co_departamento}`)
                    .then(response => {
                        commit('SET_MANUALES_PROCEDIMIENTOS_ALL', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchInstructivo({ commit }, co_documento_instructivo) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/sistemaDocumentos/instructivo/${co_documento_instructivo}`)
                    .then(response => {
                        commit('SET_INSTRUCTIVO', response.data[0])
                        resolve(response.data.length)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchInstructivos({ commit }, co_departamento) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/sistemaDocumentos/instructivos/${co_departamento}`)
                    .then(response => {
                        commit('SET_INSTRUCTIVOS', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchInstructivosAll({ commit }, co_departamento) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/sistemaDocumentos/instructivos_all/${co_departamento}`)
                    .then(response => {
                        commit('SET_INSTRUCTIVOS_ALL', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postObtenerFoto(_, data) {
            return new Promise((resolve, reject) => {
                axios({
                    method: 'post',
                    url: '/api/auth/sistemaDocumentos/foto',
                    responseType: 'blob',
                    data,
                })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postSubirDocumentos(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/sistemaDocumentos/subirDocumentos', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postSubirInstructivos(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/sistemaDocumentos/subirInstructivos', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postPermisoDepartamento(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/sistemaDocumentos/permisoDepartamento', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postEditarPermisoDepartamento(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/sistemaDocumentos/editarPermisoDepartamento', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postDescargarDiagramaFlujo(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/sistemaDocumentos/descargarDiagramaFlujo', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postCrearDocumento(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/sistemaDocumentos/crearDocumento', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postCrearDocumentoProc(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/sistemaDocumentos/crearDocumentoProc', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postCrearDocumentoInstructivo(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/sistemaDocumentos/crearDocumentoInstructivo', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postTransferirDocumento(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/sistemaDocumentos/transferirDocumento', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postCrearGuardarDocumento(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/sistemaDocumentos/subirDocumento', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postEditarDocumento(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/sistemaDocumentos/editarDocumento', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postEditarDocumentoProc(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/sistemaDocumentos/editarDocumentoProc', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postEditarInstructivo(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/sistemaDocumentos/editarInstructivo', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postAgregarRevision(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/sistemaDocumentos/agregarRevision', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postEditarRevision(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/sistemaDocumentos/editarRevision', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postAgregarHijo(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/sistemaDocumentos/agregarHijo', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postEditarHijo(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/sistemaDocumentos/editarHijo', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
    },
}
